export const shortenText = (text) => (text?.length >= 100 ? text?.substring(0, 100) + '...' : text);
